// import { Loader } from '@/design-system/loader';
import { Center, Spinner } from '@chakra-ui/react';

export const KCenterSpinner = ({ spinnerProps = {}, ...props }) => {
  return (
    <Center h="100vh" {...props}>
      <Spinner color="primary-800" {...spinnerProps} />
    </Center>
  );
};
